import { Link } from "react-router-dom";
import { Chevron } from "../../Icons";
import style from "./index.module.css";

const BrandImage = ({
  image,
  name,
  link,
  feature,
  featureLink,
  hasLink = true,
  styleobject,
}: ComponentPropsType) => {
  return (
    <div
      className={style.vehicle_brand}
      {...(styleobject ? { style: styleobject } : {})}
    >
      {hasLink ? (
        <Link to={link}>
          <div className={style.vehicle_brand__title}>
            <img src={image} alt="" />
            {name}
          </div>
        </Link>
      ) : (
        <div className={style.vehicle_brand__title}>
          <img src={image} alt="" />
          {name}
        </div>
      )}
      {feature && featureLink && (
        <div className={style.vehicle_brand__feature}>
          <Link to={featureLink}>
            {feature}
            <Chevron width="10" height="10" color="#fff" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default BrandImage;

export type ComponentPropsType = {
  image: string;
  name: string;
  link: string;
  hasLink?: boolean;
  feature?: string;
  featureLink?: string;
  styleobject?: any;
};
